import React from 'react';
import styles from './index.module.less';
import { useTranslation } from 'next-i18next';
import { Button } from 'antd';
import Image from 'next/image';

type Props = {
  onSearchClick: (text: string) => void;
  loading: boolean;
  inputValueControl: [string, (searchStr: string) => void];
};

const TopSearchContent = ({ onSearchClick, loading, inputValueControl }: Props) => {
  const { t } = useTranslation();
  const [searchStr, setSearchStr] = inputValueControl;

  return (
    <section className={styles.content}>
      <div className={styles.inputContainer}>
        <Image src={'/images/home/instagram-icon.webp'} alt="instagram" width={24} height={24} />
        <input
          className={styles.input}
          value={searchStr}
          onChange={(e) => {
            setSearchStr(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e?.key === 'Enter') {
              const value = (e.target as HTMLInputElement).value.trim();
              setSearchStr(value);
              onSearchClick(value);
            }
          }}
          placeholder={t('Enter an Instagram username or profile link')}
        />
        <Button loading={loading} className={styles.searchBtn} onClick={() => onSearchClick(searchStr)}>
          {t('Search Now')}
        </Button>
      </div>
    </section>
  );
};

export default TopSearchContent;
